var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.2168 5.42188C3.85833 0.852775 9.58093 -0.838287 14.2344 1.64453C19.037 4.2071 20.8974 10.2511 18.373 15.1455C15.8506 20.0358 9.91658 21.915 5.11914 19.3555H5.11816C3.4947 18.4897 2.14608 17.18 1.21777 15.5771L2.62012 14.8271C4.10297 17.3265 6.7744 18.873 9.67676 18.873C14.2343 18.8728 17.917 15.1145 17.917 10.5C17.9168 5.8856 14.2342 2.1272 9.67676 2.12695C6.77407 2.12695 4.1052 3.67397 2.62012 6.17285L1.2168 5.42188ZM13.458 9.92285C13.7687 10.2391 13.7708 10.7567 13.458 11.0781L9.35352 15.252L8.22852 14.1084L10.1426 12.1631L10.9785 11.3125H0.5V9.68848H10.9785L10.1426 8.83789L8.22852 6.8916L9.35352 5.74805L13.458 9.92285Z",
    fill: "#DC3A3F",
    stroke: "#E13E3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.26ecf5c41044c9f8dd93e791b4bb6a65.svg";
export { ForwardRef as ReactComponent };